// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.user-table{
    margin-top: 20px;
    max-height: calc(100vh - 280px); /* Set a max height to enable scrolling */
    overflow-y: scroll; 
    /* padding:0px 20px; */
 }
 
 .user-table::-webkit-scrollbar {
    width: 0; /* Set the width of the scrollbar to a minimal value */
  }
  
  .user-table::-webkit-scrollbar-thumb {
    background: none; /* Set the scrollbar thumb to be transparent */
  }

 .user-table-head{
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    text-align: center;
    background-color: #0059B2;
    color: #FFFFFF;
    padding: 20px 10px;
    border-radius: 10px;
    position: sticky;
  top: 0;
  z-index: 1;

 }


 .user-table-body{
    display: grid;
    grid-template-columns: repeat(4, minmax(0, 1fr));
    text-align: center;
    padding: 20px 10px;
    border-radius: 25px;
    margin: 20px 10px;
    border: 1px solid lightgray;
    font-size:15px;
    align-items: center;
    justify-content: center;
 }


 .user-table-body>div{
   padding: 0px 10px;
 }

 .user-table-body:hover{
    transform: scale(1.01);
 }

 .add-user-form{
    width: 800px;
    box-shadow: 0px 0px 2px gray;
    padding: 20px;
    text-align: center;
    border-radius: 20px;
 }

 .submits1-button{
    padding: 15px 50px !important;
    border-radius: 25px !important;
    margin-top: 20px !important;
    margin-bottom: 20px !important;
 }`, "",{"version":3,"sources":["webpack://./src/components/User/Users.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,+BAA+B,EAAE,yCAAyC;IAC1E,kBAAkB;IAClB,sBAAsB;CACzB;;CAEA;IACG,QAAQ,EAAE,sDAAsD;EAClE;;EAEA;IACE,gBAAgB,EAAE,8CAA8C;EAClE;;CAED;IACG,aAAa;IACb,gDAAgD;IAChD,kBAAkB;IAClB,yBAAyB;IACzB,cAAc;IACd,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;EAClB,MAAM;EACN,UAAU;;CAEX;;;CAGA;IACG,aAAa;IACb,gDAAgD;IAChD,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;IACjB,2BAA2B;IAC3B,cAAc;IAId,mBAAmB;IACnB,uBAAuB;CAJ1B;;;CAQA;GACE,iBAAiB;CACnB;;CAEA;IACG,sBAAsB;CACzB;;CAEA;IACG,YAAY;IACZ,4BAA4B;IAC5B,aAAa;IACb,kBAAkB;IAClB,mBAAmB;CACtB;;CAEA;IACG,6BAA6B;IAC7B,8BAA8B;IAC9B,2BAA2B;IAC3B,8BAA8B;CACjC","sourcesContent":[".user-table{\n    margin-top: 20px;\n    max-height: calc(100vh - 280px); /* Set a max height to enable scrolling */\n    overflow-y: scroll; \n    /* padding:0px 20px; */\n }\n \n .user-table::-webkit-scrollbar {\n    width: 0; /* Set the width of the scrollbar to a minimal value */\n  }\n  \n  .user-table::-webkit-scrollbar-thumb {\n    background: none; /* Set the scrollbar thumb to be transparent */\n  }\n\n .user-table-head{\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    text-align: center;\n    background-color: #0059B2;\n    color: #FFFFFF;\n    padding: 20px 10px;\n    border-radius: 10px;\n    position: sticky;\n  top: 0;\n  z-index: 1;\n\n }\n\n\n .user-table-body{\n    display: grid;\n    grid-template-columns: repeat(4, minmax(0, 1fr));\n    text-align: center;\n    padding: 20px 10px;\n    border-radius: 25px;\n    margin: 20px 10px;\n    border: 1px solid lightgray;\n    font-size:15px;\n }\n\n .user-table-body{\n    align-items: center;\n    justify-content: center;\n }\n\n\n .user-table-body>div{\n   padding: 0px 10px;\n }\n\n .user-table-body:hover{\n    transform: scale(1.01);\n }\n\n .add-user-form{\n    width: 800px;\n    box-shadow: 0px 0px 2px gray;\n    padding: 20px;\n    text-align: center;\n    border-radius: 20px;\n }\n\n .submits1-button{\n    padding: 15px 50px !important;\n    border-radius: 25px !important;\n    margin-top: 20px !important;\n    margin-bottom: 20px !important;\n }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
